import { Slider } from "@/components/ui/slider";
import { Input } from "@/components/ui/input";
import { employeePct, withContrib, perPaycheck, perPaycheckLimit, convertContrib, tspLimit } from "@/lib/finance";
import { usd } from "@/lib/format";

export function ContribModeToggle({ mode, onChange, testid }) {
  return (
    <div className="inline-flex rounded-full border border-border p-0.5 text-xs" role="group" data-testid={testid}>
      {[["percent", "% of pay"], ["fixed", "$ / paycheck"]].map(([m, l]) => (
        <button key={m} type="button" onClick={() => onChange(m)} data-testid={`${testid}-${m}`}
          className={`rounded-full px-3 py-1 transition-colors duration-200 ${mode === m ? "bg-foreground text-background" : "text-muted-foreground hover:text-foreground"}`}>{l}</button>
      ))}
    </div>
  );
}

export function ContribInput({ profile, value, onChange, testid }) {
  const salary = Number(profile.salary) || 0;
  const pct = employeePct(withContrib(profile, value), salary);
  const fixed = value.mode === "fixed";
  const maxPct = Math.ceil((tspLimit(profile.age) / (salary || 1)) * 1000) / 10;
  const max = fixed ? Math.ceil(perPaycheckLimit(profile) / 10) * 10 : Math.max(40, maxPct);
  const label = fixed ? `${usd(value.value)} / paycheck · ≈ ${pct.toFixed(1)}%` : `${value.value}% · ≈ ${usd(perPaycheck(profile, value.value))} / paycheck`;
  return (
    <div className="space-y-3" data-testid={testid}>
      <div className="flex items-center justify-between gap-2 flex-wrap">
        <span className="text-sm">TSP contribution</span>
        <ContribModeToggle mode={value.mode} onChange={(m) => onChange(convertContrib(profile, value, m))} testid={`${testid}-mode`} />
      </div>
      <div className="flex items-center gap-3">
        <Slider className="flex-1" min={0} max={max} step={fixed ? 5 : 0.5} value={[Math.min(value.value, max)]} onValueChange={([v]) => onChange({ ...value, value: v })} data-testid={`${testid}-slider`} />
        <Input type="number" min={0} className="w-24 font-mono-num h-8 text-sm" value={value.value} onChange={(e) => onChange({ ...value, value: Math.max(0, Number(e.target.value) || 0) })} data-testid={`${testid}-input`} />
      </div>
      <p className="text-xs font-mono-num text-muted-foreground" data-testid={`${testid}-value`}>{label}</p>
    </div>
  );
}
